/**
 * Truncates a string to a maximum length, adding ellipsis if needed
 */
export const truncateLabel = (
    label: string,
    maxLength: number = 40
): string => {
    if (label.length <= maxLength) return label;
    return `${label.substring(0, maxLength - 3)}...`;
};
